
import { Hotel, HotelPrice, SearchFilters } from './types';

export const MOCK_HOTELS: Hotel[] = [
  {
    id: "h1",
    name: "Grand Plaza Hotel",
    location: "Downtown",
    city: "New York",
    country: "USA",
    stars: 5,
    rating: 4.8,
    reviewCount: 1243,
    thumbnail: "https://images.unsplash.com/photo-1566073771259-6a8506099945?q=80&w=2070&auto=format&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1566073771259-6a8506099945?q=80&w=2070&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1551882547-ff40c63fe5fa?q=80&w=2070&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?q=80&w=2070&auto=format&fit=crop"
    ],
    description: "Luxurious hotel in the heart of Manhattan with stunning city views. Offering world-class amenities and exceptional service.",
    amenities: ["Free WiFi", "Pool", "Spa", "Fitness Center", "Restaurant", "Bar", "Room Service", "Concierge"],
    coordinates: {
      lat: 40.7128,
      lng: -74.0060
    }
  },
  {
    id: "h2",
    name: "Seaside Resort & Spa",
    location: "Beachfront",
    city: "Miami",
    country: "USA",
    stars: 4,
    rating: 4.5,
    reviewCount: 825,
    thumbnail: "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?q=80&w=2070&auto=format&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?q=80&w=2070&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1571896349842-33c89424de2d?q=80&w=2080&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1584132967334-10e028bd69f7?q=80&w=2070&auto=format&fit=crop"
    ],
    description: "Beautiful beachfront resort with direct access to pristine beaches. Enjoy spectacular ocean views and world-class spa facilities.",
    amenities: ["Private Beach", "Free WiFi", "Outdoor Pool", "Spa", "Restaurant", "Bar", "Room Service"],
    coordinates: {
      lat: 25.7617,
      lng: -80.1918
    }
  },
  {
    id: "h3",
    name: "Mountain View Lodge",
    location: "Mountain Region",
    city: "Denver",
    country: "USA",
    stars: 4,
    rating: 4.7,
    reviewCount: 652,
    thumbnail: "https://images.unsplash.com/photo-1548704806-0c20f7ea6474?q=80&w=2069&auto=format&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1548704806-0c20f7ea6474?q=80&w=2069&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1584132915807-fd1f5fbc078f?q=80&w=2070&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1540304453527-29bb2a0f065e?q=80&w=2070&auto=format&fit=crop"
    ],
    description: "Scenic mountain retreat with breathtaking views. Perfect for nature lovers and outdoor enthusiasts.",
    amenities: ["Free WiFi", "Fireplace", "Restaurant", "Hiking Trails", "Ski Storage", "Parking"],
    coordinates: {
      lat: 39.7392,
      lng: -104.9903
    }
  },
  {
    id: "h4",
    name: "Historic Boutique Hotel",
    location: "Old Town",
    city: "Boston",
    country: "USA",
    stars: 4,
    rating: 4.6,
    reviewCount: 413,
    thumbnail: "https://images.unsplash.com/photo-1564501049412-61c2a3083791?q=80&w=2089&auto=format&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1564501049412-61c2a3083791?q=80&w=2089&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1560624052-449f5ddf0c31?q=80&w=2070&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1560624052-449f5ddf0c31?q=80&w=2070&auto=format&fit=crop"
    ],
    description: "Charming boutique hotel in a historic building. Combining old-world charm with modern amenities.",
    amenities: ["Free WiFi", "Restaurant", "Bar", "Room Service", "Concierge", "Library"],
    coordinates: {
      lat: 42.3601,
      lng: -71.0589
    }
  },
  {
    id: "h5",
    name: "Urban Chic Hotel",
    location: "Downtown",
    city: "San Francisco",
    country: "USA",
    stars: 4,
    rating: 4.4,
    reviewCount: 578,
    thumbnail: "https://images.unsplash.com/photo-1578683010236-d716f9a3f461?q=80&w=2070&auto=format&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1578683010236-d716f9a3f461?q=80&w=2070&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1587985064135-0366536eab42?q=80&w=2070&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1590490360182-c33d57733427?q=80&w=2074&auto=format&fit=crop"
    ],
    description: "Modern hotel in the heart of San Francisco. Close to major attractions and business districts.",
    amenities: ["Free WiFi", "Fitness Center", "Restaurant", "Bar", "Business Center", "Parking"],
    coordinates: {
      lat: 37.7749,
      lng: -122.4194
    }
  },
  {
    id: "h6",
    name: "Riverside Inn",
    location: "Riverside",
    city: "Chicago",
    country: "USA",
    stars: 3,
    rating: 4.2,
    reviewCount: 325,
    thumbnail: "https://images.unsplash.com/photo-1551632436-cbf8dd35adfa?q=80&w=2071&auto=format&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1551632436-cbf8dd35adfa?q=80&w=2071&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1568084680786-a84f91d1153c?q=80&w=2074&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1611892440504-42a792e24d32?q=80&w=2070&auto=format&fit=crop"
    ],
    description: "Comfortable hotel with beautiful river views. Offering a relaxed atmosphere and friendly service.",
    amenities: ["Free WiFi", "Restaurant", "Bar", "Parking", "Air Conditioning"],
    coordinates: {
      lat: 41.8781,
      lng: -87.6298
    }
  }
];

export const MOCK_PRICES: HotelPrice[] = [
  // Hotel 1 prices
  {
    hotelId: "h1",
    provider: "Booking.com",
    price: 299,
    currency: "USD",
    originalPrice: 350,
    discount: 15,
    providerLogo: "https://cdn.freebiesupply.com/logos/large/2x/booking-com-logo-png-transparent.png",
    roomType: "Deluxe Room",
    cancellationPolicy: "Free cancellation",
    breakfast: true,
    wifi: true
  },
  {
    hotelId: "h1",
    provider: "Expedia",
    price: 310,
    currency: "USD",
    originalPrice: 349,
    discount: 11,
    providerLogo: "https://logos-world.net/wp-content/uploads/2021/08/Expedia-Logo-2012-2018.png",
    roomType: "Deluxe Room",
    cancellationPolicy: "Free cancellation",
    wifi: true
  },
  {
    hotelId: "h1",
    provider: "Hotels.com",
    price: 305,
    currency: "USD",
    originalPrice: 330,
    discount: 8,
    providerLogo: "https://logos-world.net/wp-content/uploads/2021/08/Hotels-com-Logo-2009-2018.png",
    roomType: "Deluxe Room",
    cancellationPolicy: "Non-refundable",
    breakfast: true
  },
  
  // Hotel 2 prices
  {
    hotelId: "h2",
    provider: "Booking.com",
    price: 210,
    currency: "USD",
    originalPrice: 250,
    discount: 16,
    providerLogo: "https://cdn.freebiesupply.com/logos/large/2x/booking-com-logo-png-transparent.png",
    roomType: "Ocean View Room",
    cancellationPolicy: "Free cancellation",
    breakfast: true,
    wifi: true
  },
  {
    hotelId: "h2",
    provider: "Expedia",
    price: 219,
    currency: "USD",
    originalPrice: 270,
    discount: 19,
    providerLogo: "https://logos-world.net/wp-content/uploads/2021/08/Expedia-Logo-2012-2018.png",
    roomType: "Ocean View Room",
    cancellationPolicy: "Free cancellation",
    wifi: true
  },
  {
    hotelId: "h2",
    provider: "Hotels.com",
    price: 215,
    currency: "USD",
    providerLogo: "https://logos-world.net/wp-content/uploads/2021/08/Hotels-com-Logo-2009-2018.png",
    roomType: "Garden View Room",
    cancellationPolicy: "Free cancellation",
    breakfast: true,
    wifi: true
  },
  
  // Hotel 3 prices
  {
    hotelId: "h3",
    provider: "Booking.com",
    price: 175,
    currency: "USD",
    originalPrice: 200,
    discount: 13,
    providerLogo: "https://cdn.freebiesupply.com/logos/large/2x/booking-com-logo-png-transparent.png",
    roomType: "Mountain View Room",
    cancellationPolicy: "Free cancellation",
    wifi: true
  },
  {
    hotelId: "h3",
    provider: "Expedia",
    price: 180,
    currency: "USD",
    providerLogo: "https://logos-world.net/wp-content/uploads/2021/08/Expedia-Logo-2012-2018.png",
    roomType: "Mountain View Room",
    cancellationPolicy: "Non-refundable",
    breakfast: true
  },
  {
    hotelId: "h3",
    provider: "Hotels.com",
    price: 172,
    currency: "USD",
    originalPrice: 210,
    discount: 18,
    providerLogo: "https://logos-world.net/wp-content/uploads/2021/08/Hotels-com-Logo-2009-2018.png",
    roomType: "Standard Room",
    cancellationPolicy: "Free cancellation",
    breakfast: true,
    wifi: true
  },
  
  // Hotel 4 prices
  {
    hotelId: "h4",
    provider: "Booking.com",
    price: 195,
    currency: "USD",
    providerLogo: "https://cdn.freebiesupply.com/logos/large/2x/booking-com-logo-png-transparent.png",
    roomType: "Classic Room",
    cancellationPolicy: "Free cancellation",
    wifi: true
  },
  {
    hotelId: "h4",
    provider: "Expedia",
    price: 188,
    currency: "USD",
    originalPrice: 210,
    discount: 10,
    providerLogo: "https://logos-world.net/wp-content/uploads/2021/08/Expedia-Logo-2012-2018.png",
    roomType: "Classic Room",
    cancellationPolicy: "Free cancellation",
    breakfast: true,
    wifi: true
  },
  {
    hotelId: "h4",
    provider: "Hotels.com",
    price: 200,
    currency: "USD",
    providerLogo: "https://logos-world.net/wp-content/uploads/2021/08/Hotels-com-Logo-2009-2018.png",
    roomType: "Deluxe Room",
    cancellationPolicy: "Non-refundable",
    breakfast: true,
    wifi: true
  },
  
  // Hotel 5 prices
  {
    hotelId: "h5",
    provider: "Booking.com",
    price: 230,
    currency: "USD",
    originalPrice: 270,
    discount: 15,
    providerLogo: "https://cdn.freebiesupply.com/logos/large/2x/booking-com-logo-png-transparent.png",
    roomType: "City View Room",
    cancellationPolicy: "Free cancellation",
    wifi: true
  },
  {
    hotelId: "h5",
    provider: "Expedia",
    price: 245,
    currency: "USD",
    providerLogo: "https://logos-world.net/wp-content/uploads/2021/08/Expedia-Logo-2012-2018.png",
    roomType: "City View Room",
    cancellationPolicy: "Free cancellation",
    breakfast: true,
    wifi: true
  },
  {
    hotelId: "h5",
    provider: "Hotels.com",
    price: 240,
    currency: "USD",
    originalPrice: 275,
    discount: 13,
    providerLogo: "https://logos-world.net/wp-content/uploads/2021/08/Hotels-com-Logo-2009-2018.png",
    roomType: "Standard Room",
    cancellationPolicy: "Non-refundable",
    wifi: true
  },
  
  // Hotel 6 prices
  {
    hotelId: "h6",
    provider: "Booking.com",
    price: 145,
    currency: "USD",
    originalPrice: 170,
    discount: 15,
    providerLogo: "https://cdn.freebiesupply.com/logos/large/2x/booking-com-logo-png-transparent.png",
    roomType: "River View Room",
    cancellationPolicy: "Free cancellation",
    breakfast: true
  },
  {
    hotelId: "h6",
    provider: "Expedia",
    price: 155,
    currency: "USD",
    providerLogo: "https://logos-world.net/wp-content/uploads/2021/08/Expedia-Logo-2012-2018.png",
    roomType: "Standard Room",
    cancellationPolicy: "Non-refundable",
    wifi: true
  },
  {
    hotelId: "h6",
    provider: "Hotels.com",
    price: 150,
    currency: "USD",
    originalPrice: 180,
    discount: 17,
    providerLogo: "https://logos-world.net/wp-content/uploads/2021/08/Hotels-com-Logo-2009-2018.png",
    roomType: "River View Room",
    cancellationPolicy: "Free cancellation",
    breakfast: true,
    wifi: true
  }
];

// Popular destinations
export const POPULAR_DESTINATIONS = [
  { name: "New York", country: "USA", image: "https://images.unsplash.com/photo-1496442226666-8d4d0e62e6e9?q=80&w=2070&auto=format&fit=crop" },
  { name: "Paris", country: "France", image: "https://images.unsplash.com/photo-1502602898657-3e91760cbb34?q=80&w=2073&auto=format&fit=crop" },
  { name: "London", country: "UK", image: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?q=80&w=2070&auto=format&fit=crop" },
  { name: "Tokyo", country: "Japan", image: "https://images.unsplash.com/photo-1540959733332-eab4deabeeaf?q=80&w=2071&auto=format&fit=crop" },
  { name: "Rome", country: "Italy", image: "https://images.unsplash.com/photo-1552832230-c0197dd311b5?q=80&w=2069&auto=format&fit=crop" },
  { name: "Sydney", country: "Australia", image: "https://images.unsplash.com/photo-1506973035872-a4ec16b8e8d9?q=80&w=2070&auto=format&fit=crop" }
];

export function searchHotels(filters: Partial<SearchFilters>) {
  // In a real app, this would filter based on the criteria
  return MOCK_HOTELS;
}

export function getHotelById(id: string): Hotel | undefined {
  return MOCK_HOTELS.find(hotel => hotel.id === id);
}

export function getHotelPrices(hotelId: string): HotelPrice[] {
  return MOCK_PRICES.filter(price => price.hotelId === hotelId);
}
